<aside class="absolute z-10 h-full bg-white w-60">
  <app-logo />
  <nav class="mt-4">
    <app-menu [items]="(menuItems$ | async) ?? []" />
  </nav>
</aside>

<!-- Main Content Area -->
<main class="relative flex flex-col flex-1 ml-60">
  <app-topbar class="absolute" />

  <!-- Content Area -->
  <div class="flex-1 px-10 py-4 mt-16 overflow-auto min-h-ful bg-background-50">
    <router-outlet />
  </div>
</main>

<app-backdrop [visible]="(loading$ | async) ?? false">
  <app-spinner [loading]="true" />
</app-backdrop>
